<div class="modal fade auth-modal" id="write-testimonial-confirm" data-keyboard="false" 
tabindex="-1" aria-hidden="true" *ngIf="midwife">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body">
                <div class="d-flex flex-row justify-content-between mt-3 mb-2 px-3">
                    <span class="modal-title">Write testimonial</span>
                    <i class="fas fa-times modal-close" data-dismiss="modal"></i>
                </div>
                <div class="horizontal-line mb-3"></div>
                <div class="d-flex flex-column text-center mx-3">
                    <img class="profile-img my-2" [src]="midwife.profileImage">
                    <span class="mt-2 modal-text">Write a testimonial about the care provided by</span>
                    <span class="mt-1 profile-name">{{midwife.name}}</span>
                </div>
                <div class="d-flex flex-row justify-content-center mt-4 mx-3 mb-3">
                    <button class="btn btn-cancel mr-2" data-dismiss="modal">Not Now</button>
                    <button class="btn btn-theme" data-toggle="modal" data-dismiss="modal" data-target="#write-testimonial">Write Now</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade auth-modal" id="write-testimonial" data-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body">
                <div class="d-flex flex-row justify-content-between mt-3 mb-2 px-3">
                    <span class="modal-title">Write testimonial</span>
                    <i class="fas fa-times modal-close" data-dismiss="modal" (click)="clearData()"></i>
                </div>
                <div class="horizontal-line mb-3"></div>
                <div class="d-flex flex-column mx-3">
                    <span class="input-label mb-2">Write your testimonial</span>
                    <textarea class="form-control form-control-sm" rows="15" [(ngModel)]="testimonial"></textarea>
                </div>
                <div class="d-flex flex-row justify-content-end mt-4 mx-3 mb-3">
                    <button class="btn btn-cancel mr-2" data-dismiss="modal" (click)="clearData()">Cancel</button>
                    <button class="btn btn-theme" [disabled]="testimonial.length < 10"
                    (click)="createTestimonial()">Submit</button>
                </div>
            </div>
        </div>
    </div>
</div>